import tippy from "tippy.js";

export class DomUtils {

    static textFromHtml(html) {

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        return tempDiv.textContent.trim();
    }

    static addTooltip(element, text, options = {}) {

        // do not initialize tooltip on same element more than once
        if (!element._tippy) {

            const finalOptions = {
                delay: 0,
                duration: 0,
                animation: false,
                theme: 'light',
                arrow: false,
                content: text,
                ...options
            };

            tippy(element, finalOptions);
        }
    }

    /**
     *
     * @param {string} name
     * @return {{}|string|null}
     */
    static getMetaContents(name) {

        const metaElement = document.querySelector('meta[name=' + name + ']');

        if (metaElement) {
            const content = metaElement.getAttribute('content');

            try {
                return JSON.parse(content);
            } catch (e) {

            }

            return content;
        }

        return null;
    }

    /**
     *
     * @param selector
     * @param {number} offsetTop
     * @return {null|HTMLElement}
     */
    static findFirstVisibleElement(selector, offsetTop = 0) {

        let result = null;
        let smallestTop = null;

        const elements = document.querySelectorAll(selector);
        for (const element of elements) {
            const rect = element.getBoundingClientRect();

            // negative value means that the top of the element is scrolled out of view at the top of the viewport
            const elementTopIncludingOffset = rect.top - offsetTop;

            // find element with smallest POSITIVE top offset
            if (elementTopIncludingOffset >= 0) {

                if (smallestTop === null || elementTopIncludingOffset < smallestTop) {
                    smallestTop = elementTopIncludingOffset;
                    result = element;
                }
            }
        }

        return result;
    }

    static updatePageTitle(newPageTitle) {
        // TODO: modify actual <title>
        document.title = newPageTitle;
    }
}
